module.exports = globalThis.inkjs;